module.exports = __webpack_public_path__ + "img/thumbnail_EuropeanFallowDeer_m_leucistic.eb282d70.png";